/**
 * MessageTemplatePresenter
 * --
 */
import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  TabMenu,
  InputFormTable,
  Text,
  ModalLayout,
  Editor,
} from 'components';
import { Button, Empty, Input, Select, Switch, Tabs } from 'antd';

// NOTE: 템플릿 관련 변수
// 템플릿 추가 시 선언 필요합니다
import CONSTANTS from 'constants';

const TAP = [
  {
    label: '푸시알림',
    key: 'PUSH',
  },
  {
    label: '이메일',
    key: 'EMAIL',
  },
  {
    label: '문자',
    key: 'SMS',
  },
];

/**----------------------------------------
 * [Component] NotificationListContainer
 * ----------------------------------------
 */
const MessageTemplatePresenter = ({
  tapKey,
  data,
  onTabChange,
  selectedData,
  tempContent,
  onChange,
  onSubmit,
  type,
  setType,
  setTempContent,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [isOpened, setIsOpened] = React.useState(false);

  /* ===== VARIABLE ===== */
  // SECTION: Style
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },

    row: {
      display: 'flex',
      alignItems: 'stretch',
      borderBottom: '1px solid #E9E9E9',
    },
    rowVar: {
      flex: 1,
      padding: '20px 10px',
      borderRight: '1px solid #E9E9E9',
    },
    rowValue: {
      flex: 2,
      padding: '20px 10px',
    },
  };

  const form = {
    PUSH: [
      {
        label: `제목`,
        form: [
          {
            input: (
              <>
                <Input
                  size="large"
                  style={{ ...styles.form.input.large, width: '100%' }}
                  placeholder={`푸시알림 제목을 입력해주세요`}
                  value={tempContent?.title}
                  onChange={(e) => onChange('title', e.target.value)}
                />
              </>
            ),
            fullscreen: true,
          },
        ],
      },
      {
        label: '내용',
        form: [
          {
            input: (
              <>
                <Input.TextArea
                  size="large"
                  style={{
                    ...styles.form.input.large,
                    width: '100%',
                    height: 140,
                  }}
                  placeholder={'내용을 입력해주세요'}
                  value={tempContent?.body}
                  onChange={(e) => onChange('body', e.target.value)}
                />
              </>
            ),
            fullscreen: true,
          },
        ],
      },
      {
        label: `태그`,
        form: [
          {
            input: (
              <>
                <Select
                  size="large"
                  options={[
                    { label: '프로모션/이벤트', value: 'EVENT' },
                    { label: '쿠폰', value: 'COUPON' },
                    { label: '선물', value: 'PRESENT' },
                    { label: '오더', value: 'ORDER' },
                    { label: '주문', value: 'SHOP' },
                    { label: '카드 충전', value: 'CHARGE' },
                    { label: '시스템 공지', value: 'NOTICE' },
                    { label: '기타', value: null },
                  ]}
                  value={tempContent?.tag}
                  onChange={(e) => onChange('tag', e)}
                  placeholder={'태그'}
                />
              </>
            ),
            fullscreen: true,
          },
        ],
      },
    ],
    EMAIL: [
      {
        label: `제목`,
        form: [
          {
            input: (
              <>
                <Input
                  size="large"
                  style={{ ...styles.form.input.large, width: '100%' }}
                  placeholder={`이메일 제목을 입력해주세요`}
                  value={tempContent?.subject}
                  onChange={(e) => onChange('subject', e.target.value)}
                />
              </>
            ),
            fullscreen: true,
          },
        ],
      },
      {
        label: '내용',
        form: [
          {
            input: (
              <>
                <Editor
                  placeholder={'내용을 입력해주세요'}
                  initialContent={tempContent?.html}
                  editorOnChange={(content) => onChange('html', content)}
                  height={430}
                />
              </>
            ),
            fullscreen: true,
          },
        ],
      },
    ],
    SMS: [
      {
        label: '내용',
        form: [
          {
            input: (
              <>
                <Input.TextArea
                  size="large"
                  style={{
                    ...styles.form.input.large,
                    width: '100%',
                    height: 140,
                  }}
                  placeholder={'내용을 입력해주세요'}
                  value={tempContent}
                  onChange={(e) => setTempContent(e.target.value)}
                />
              </>
            ),
            fullscreen: true,
          },
        ],
      },
    ],
    ALIM_TALK: [
      {
        label: `코드`,
        form: [
          {
            input: (
              <>
                <Input
                  size="large"
                  style={{ ...styles.form.input.large, width: '100%' }}
                  placeholder={`알림톡 코드 입력해주세요`}
                  value={tempContent}
                  onChange={(e) => setTempContent(e.target.value)}
                />
              </>
            ),
            fullscreen: true,
          },
        ],
      },
    ],
  };

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /**
   * SECTION 템플릿 목록
   * --
   */
  const template = React.useMemo(() => {
    const templateType = {
      ORDER: '오더',
      USER: '사용자',
      ADMIN: '관리자',
      STORE_ADMIN: '매장 관리자',
    };

    const newTemplate = data?.[type]?.reduce((acc, cur) => {
      // cur.user_type을 기준으로 그룹화
      if (acc[cur.user_type]) {
        acc[cur.user_type].push(cur); // 이미 그룹이 존재하면 추가
      } else {
        acc[cur.user_type] = [cur]; // 그룹이 없으면 새 배열 생성
      }
      return acc;
    }, {});

    return Object.entries(newTemplate).map(([key, value]) => ({
      title: templateType[key],
      children: value,
    }));
  }, [data, type]);

  // console.log('currentType: ', currentType);

  /* ===== RENDER ===== */
  return (
    <React.Fragment>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            <Title style={{ ...styles.title }}>템플릿 관리</Title>

            <Row gutter={[1, 1]}>
              <Col x={4}>
                <Content
                  maxWidth={'100%'}
                  style={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  padding={'12px 12px 0px'}
                >
                  <Tabs
                    activeKey={type}
                    items={TAP}
                    onChange={(key) => setType(key)}
                  />
                </Content>
              </Col>

              <Col x={20}>
                <Content
                  maxWidth={'100%'}
                  style={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <h2
                    style={{
                      fontSize: 18,
                      fontWeight: 600,
                      color: '#404040',
                      lineHeight: '133%',
                    }}
                  >
                    {TAP.find((tap) => tap.key === type)?.label} 템플릿 등록
                  </h2>
                </Content>
              </Col>

              <Col
                x={4}
                style={{
                  background: '#FFFFFF',
                }}
              >
                <Content
                  maxWidth={'100%'}
                  style={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 20,
                  }}
                >
                  {template.map((temp, index) => (
                    <React.Fragment key={`temp-${index}`}>
                      <Content maxWidth={'100%'} padding={0}>
                        <Text size={14} weight={700}>
                          {temp.title}
                        </Text>

                        {temp.children.length ? (
                          <TabMenu
                            activeKey={tapKey}
                            items={temp.children.map((child) => ({
                              label:
                                child[`${[type.toLocaleLowerCase()]}_title`],
                              key: child[
                                `${type.toLocaleLowerCase()}_template_id`
                              ],
                              value: child.place_holder,
                              type: child.user_type,
                            }))}
                            onChange={({ key, value, type }) =>
                              onTabChange(key, value, type)
                            }
                            multi={false}
                          />
                        ) : (
                          <Empty />
                        )}
                      </Content>
                    </React.Fragment>
                  ))}
                </Content>
              </Col>

              <Col x={20}>
                <Content
                  maxWidth={'100%'}
                  padding={10}
                  style={{ height: '100%' }}
                >
                  <Content
                    maxWidth={'100%'}
                    padding={24}
                    backgroundColor="#F4F4F5"
                    style={{
                      marginBottom: 20,
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <div>
                      <Title style={{ marginBottom: 10 }}>
                        {selectedData?.[`${type.toLocaleLowerCase()}_title`]}
                      </Title>

                      <p>
                        {
                          selectedData?.[
                            `${type.toLocaleLowerCase()}_description`
                          ]
                        }
                      </p>
                    </div>

                    {type === 'ALIM_TALK' ? null : (
                      <Button onClick={() => setIsOpened(!isOpened)}>
                        변수보기
                      </Button>
                    )}
                  </Content>

                  <InputFormTable form={form[type]} />

                  {type === 'ALIM_TALK' ? null : (
                    <Content
                      maxWidth={'100%'}
                      padding={10}
                      style={{ display: 'flex', gap: 10, alignItems: 'center' }}
                    >
                      <Text size={14}>활성화 여부</Text>

                      <Switch
                        checked={selectedData?.is_enable === 'Y' ? true : false}
                        onChange={() => {
                          if (!selectedData) return;

                          onSubmit('ENABLE', {
                            [`${type.toLocaleLowerCase()}_template_id`]:
                              selectedData?.[
                                `${type.toLocaleLowerCase()}_template_id`
                              ],
                            is_enable:
                              selectedData?.is_enable === 'Y' ? 'N' : 'Y',
                          });
                        }}
                      />
                    </Content>
                  )}

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginTop: 20,
                    }}
                  >
                    <Button
                      size="large"
                      type="primary"
                      style={{
                        ...styles.button,
                      }}
                      onClick={() => onSubmit('update')}
                      disabled={type === 'EMAIL'}
                    >
                      저장
                    </Button>
                    <Button
                      size="large"
                      style={{ ...styles.button }}
                      onClick={() => onSubmit('reset')}
                      disabled={type === 'EMAIL'}
                    >
                      초기화
                    </Button>
                  </div>
                </Content>
              </Col>
              {/* 정산내역 끝 */}

              {/* <Col x={24}>
              <Content
                maxWidth={'100%'}
                style={{ marginTop: 40 }}
                borderRadius={4}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 20,
                  }}
                >
                  <h4 style={{ fontSize: 14, fontWeight: 500 }}>
                    총 <span>{data.length}</span>건
                  </h4>
                </div>
                <Table
                  data={data}
                  columns={[
                    {
                      title: '전송 번호',
                      key: '전송번호',
                    },
                    {
                      title: '발송 타입',
                      key: '발송타입',
                      render: (item) => (
                        <span
                          style={{
                            padding: '7px 3px',
                            border: '0.5px solid #B2B2B2',
                            borderRadius: 4,
                          }}
                        >
                          {item}
                        </span>
                      ),
                    },
                    {
                      title: '생성 시간',
                      key: '생성시간',
                      render: (item) =>
                        moment(item).format('YYYY-MM-DD HH:mm:ss'),
                    },
                    {
                      title: '관리자',
                      key: '관리자',
                    },
                    {
                      title: '템플릿 제목',
                      key: '템플릿제목',
                    },
                    {
                      title: '메일 제목',
                      key: '메일제목',
                      render: (item) => (
                        <button
                          style={{
                            border: 'none',
                            background: 'none',
                            textDecoration: 'underline',
                            color: '#1C6BFF',
                            cursor: 'pointer',
                          }}
                        >
                          {item}
                        </button>
                      ),
                    },
                    {
                      title: '메일 내용',
                      key: '메일내용',
                      width: 300,
                      style: {
                        maxWidth: 500,
                        padding: 8,
                      },
                    },
                    {
                      title: '비고',
                      key: '비고',
                      render: () => (
                        <>
                          <Button
                            size="small"
                            style={{
                              borderColor: 'var(--primary-color)',
                              color: 'var(--primary-color)',
                              marginRight: 4,
                            }}
                          >
                            수정
                          </Button>
                          <Button
                            size="small"
                            style={{ borderColor: '#EE4700', color: '#EE4700' }}
                          >
                            삭제
                          </Button>
                        </>
                      ),
                    },
                  ]}
                />
                <Pagination total={40} style={{ marginTop: 40 }} />
              </Content>
            </Col> */}
            </Row>
          </Col>
        </Row>
      </Content>

      <ModalLayout
        type={'modal'}
        open={isOpened}
        onCancel={setIsOpened}
        centered
        closable
        title={'사용 가능 변수'}
        width={800}
      >
        <Content
          maxWidth={'100%'}
          padding={0}
          style={{ border: '1px solid #666666C' }}
        >
          <div style={{ ...styles.row, background: '#F4F4F5' }}>
            <div style={{ ...styles.rowVar }}>
              <Text weight={600}>변수명</Text>
            </div>
            <div style={{ ...styles.rowValue }}>
              <Text weight={600}>설명</Text>
            </div>
          </div>
          {selectedData
            ? Object.keys(selectedData?.place_holder)?.map((key, index) => (
                <div
                  key={`placeholder-${key}-${index}`}
                  style={{ ...styles.row }}
                >
                  <div style={{ ...styles.rowVar }}>
                    <Text>{`{${key}}`}</Text>
                  </div>
                  <div style={{ ...styles.rowValue }}>
                    <Text>{CONSTANTS.PLACE_HOLDER[key]}</Text>
                  </div>
                </div>
              ))
            : null}
        </Content>
      </ModalLayout>
    </React.Fragment>
  );
};

export default MessageTemplatePresenter;
